var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configObj
    ? _c("div", { staticClass: "member-card-container", style: _vm.boxStyle }, [
        _c(
          "div",
          { staticClass: "member-header acea-row", style: _vm.bgImgStyle },
          [
            _c("div", { staticClass: "member-brand" }, [
              _vm.configObj.logoConfig.url && _vm.logoShow
                ? _c("img", {
                    staticClass: "brand-image",
                    attrs: {
                      src: _vm.configObj.logoConfig.url,
                      alt: "品牌logo",
                    },
                  })
                : _vm._e(),
              _c(
                "span",
                { staticClass: "brand-name", style: _vm.merNameColor },
                [_vm._v(_vm._s(_vm.configObj.titleConfig.val))]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.levelShow,
                      expression: "levelShow",
                    },
                  ],
                  staticClass: "member-level",
                  style: _vm.memNameColor,
                },
                [_vm._v("黄金会员")]
              ),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.ruleShow,
                    expression: "ruleShow",
                  },
                ],
                staticClass: "member-rule",
                style: _vm.rulesNameColor,
              },
              [_vm._v("会员规则")]
            ),
            _c("div", { staticClass: "balance-section" }, [
              _c("div", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.priceShow,
                        expression: "priceShow",
                      },
                    ],
                    staticClass: "balance-info",
                    style: _vm.moneyColor,
                  },
                  [
                    _c("span", { staticClass: "balance-label" }, [
                      _vm._v("购物余额："),
                    ]),
                    _c(
                      "span",
                      { staticClass: "balance-amount line-heightOne" },
                      [_vm._v("¥980.00")]
                    ),
                    _c("i", { staticClass: "el-icon-arrow-right" }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "recharge-btn-box" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.btnShow,
                        expression: "btnShow",
                      },
                    ],
                    staticClass: "recharge-btn",
                    style: _vm.btnColorStyle,
                  },
                  [_vm._v("充值")]
                ),
              ]),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }